<template>
    <div>
        <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box pa-5">
            <div class="d-flex flex-wrap justify-center" style="gap:16px;">
                <template v-if="!cardData.length">
                    <v-skeleton-loader v-for="n in 4" :key="n" type="list-item-three-line,image" class="mx-2"
                        style="height:120px; width:150px; border-radius:12px;" :elevation="1" />
                </template>
                <template v-else>
                    <div v-for="(card, index) in cardData" :key="index" class="responsive-card">
                        <v-hover v-slot="{ hover }">
                            <v-card flat class="pa-4 d-flex align-center" :style="{
                                backgroundColor: card.bg,
                                border: card.border1,
                                borderRadius: '8px',
                                color: '#2e2e2e',
                                transition: 'all 0.3s ease',
                                height: '70px',
                                width: '170px'
                            }">
                                <v-icon v-if="card.icon" large class="mr-4" :color="card.iconColor">{{ card.icon
                                    }}</v-icon>
                                <v-icon v-else large class="mr-4" color="#9E9E9E">mdi-help-circle</v-icon>
                                <div class="d-flex flex-column justify-center">
                                    <div class="text-subtitle-1 font-weight-medium mb-1">{{ card.title }} #</div>
                                    <div class="text-h5 font-weight-bold">{{ card.count }}</div>
                                </div>
                            </v-card>
                        </v-hover>
                    </div>
                </template>
            </div>
            <v-divider class="my-5"></v-divider>
            <div class="d-flex flex-wrap justify-center" style="gap:16px;">
                <!-- Admission Count -->
                <!-- <template v-if="new_admission_count == null">
                    <v-skeleton-loader type="list-item-three-line,image" class="mx-2"
                        style="height:120px; width:150px; border-radius:12px;" />
                </template> -->
                <!-- <template v-else>
                    <div class="d-flex flex-wrap justify-center" style="gap:16px;">
                        <div class="responsive-card">
                            <v-hover v-slot="{ hover }">
                                <v-card flat class="pa-3 d-flex align-center" style="
                            background-color:#E3F2FD;
                            border: 1px solid #64B5F6;
                            border-radius:8px; 
                            color: #2e2e2e;
                            height: 90px;
                            width: 170px;
                        ">
                                    <div class="d-flex flex-column justify-center">
                                        <div class="card-title">Subject Feedback</div>
                                        <div class="card-count">0</div>
                                    </div>
                                    <v-icon large class="ml-4" color="#1976D2">mdi-comment-text-outline</v-icon>

                                </v-card>
                            </v-hover>
                        </div>
                    </div>
                </template> -->
                <!-- Performance Index -->
                <!-- <template v-if="performance_index_count == null">
                    <v-skeleton-loader type="list-item-three-line,image" class="mx-2"
                        style="height:120px; width:150px; border-radius:12px;" />
                </template>
                <template v-else>
                    <div class="d-flex flex-wrap justify-center" style="gap:16px;">
                        <div class="responsive-card">
                            <v-hover v-slot="{ hover }">
                                <v-card flat class="pa-3 d-flex align-center" style="
                            background-color:#FFF8E1;
                            border: 1px solid #FFD54F;
                            border-radius:8px; 
                            color: #2e2e2e;
                            height: 90px;
                            width: 170px;
                        ">

                                    <div class="d-flex flex-column justify-center">
                                        <div class="card-title">Performance Index</div>
                                        <div class="card-count">{{performance_index_count}}</div>
                                    </div>
                                    <v-icon large class="ml-4" color="#F57F17">mdi-trending-up</v-icon>

                                </v-card>
                            </v-hover>
                        </div>
                    </div>
                </template> -->
                <!-- Books -->
                <template v-if="total_book_reviewed == null">
                    <v-skeleton-loader type="list-item-three-line,image" class="mx-2"
                        style="height:120px; width:150px; border-radius:12px;" />
                </template>
                <template v-else>
                    <div class="d-flex flex-wrap justify-center" style="gap:16px;">
                        <div class="responsive-card">
                            <v-hover v-slot="{ hover }">
                                <v-card flat class="pa-3 d-flex align-center" style="
                            background-color:#E8F5E9;
                            border: 1px solid #81C784;
                            border-radius:8px; 
                            color: #2e2e2e;
                            height: 90px;
                            width: 170px;
                        ">

                                    <div class="d-flex flex-column justify-center">
                                        <div class="card-title">Books</div>
                                        <div class="card-count">{{total_book_reviewed}}</div>
                                    </div>
                                    <v-icon large class="ml-4" color="#2E7D32">mdi-bookshelf</v-icon>

                                </v-card>
                            </v-hover>
                        </div>
                    </div>
                </template>
                <!-- Publications Count -->
                <template v-if="total_publications == null">
                    <v-skeleton-loader type="list-item-three-line,image" class="mx-2"
                        style="height:120px; width:150px; border-radius:12px;" />
                </template>
                <template v-else>
                    <div class="responsive-card">
                        <v-hover v-slot="{ hover }">
                            <v-card flat class="pa-3 d-flex align-center" style="
                    background-color:#FBE9E7;
                    border: 1px solid #FF8A65;
                    border-radius:8px; 
                    color: #2e2e2e;
                    height: 90px;
                    width: 170px;
                    transition: all 0.3s ease;
                " :elevation="hover ? 8 : 2">
                                <div class="d-flex flex-column justify-center flex-grow-1">
                                    <div class="card-title">Publications</div>
                                    <div class="card-count">{{total_publications}}</div>
                                </div>
                                <v-icon large class="ml-4" color="#D84315">
                                    mdi-book-open-page-variant
                                </v-icon>
                            </v-card>
                        </v-hover>
                    </div>
                </template>
                <!--  Total Training Imparted -->
                <template v-if="total_training_imparted == null">
                    <v-skeleton-loader type="list-item-three-line,image" class="mx-2"
                        style="height:120px; width:150px; border-radius:12px;" />
                </template>
                <template v-else>
                    <div class="d-flex flex-wrap justify-center" style="gap:16px;">
                        <div class="responsive-card">
                            <v-hover v-slot="{ hover }">
                                <v-card flat class="pa-3 d-flex align-center" style="
                            background-color:#E0F7FA;
                            border: 1px solid #4DD0E1;
                            border-radius:8px; 
                            color: #2e2e2e;
                            height: 90px;
                            width: 170px;
                        ">

                                    <div class="d-flex flex-column justify-center">
                                        <div class="card-title">Training Imparted</div>
                                        <div class="card-count">{{ total_training_imparted }}</div>
                                    </div>
                                    <v-icon large class="ml-4" color="#00838F">mdi-account-tie</v-icon>

                                </v-card>
                            </v-hover>
                        </div>
                    </div>
                </template>
                <!--  Student Present Today Count -->
                <template v-if="total_training_undergone == null">
                    <v-skeleton-loader type="list-item-three-line,image" class="mx-2"
                        style="height:120px; width:150px; border-radius:12px;" />
                </template>
                <template v-else>
                    <div class="d-flex flex-wrap justify-center" style="gap:16px;">
                        <div class="responsive-card">
                            <v-hover v-slot="{ hover }">
                                <v-card flat class="pa-3 d-flex align-center" style="
                            background-color:#F3E5F5;
                            border: 1px solid #BA68C8;
                            border-radius:8px; 
                            color: #2e2e2e;
                            height: 90px;
                            width: 170px;
                        ">



                                    <div class="d-flex flex-column justify-center">
                                        <div class="card-title">Training undergone</div>
                                        <div class="card-count">{{total_training_undergone}}</div>
                                    </div>
                                    <v-icon large class="ml-4" color="#6A1B9A">mdi-school</v-icon>
                                </v-card>
                            </v-hover>
                        </div>
                    </div>
                </template>
<template v-if="total_training_hours === null">
    <v-skeleton-loader type="list-item-three-line,image" class="mx-2"
        style="height:120px; width:150px; border-radius:12px;" />
</template>
<template v-else>
    <div class="d-flex flex-wrap justify-center" style="gap:16px;">
        <div class="responsive-card">
            <v-hover v-slot="{ hover }">
                <v-card flat class="pa-3 d-flex align-center" style="
                    background-color:#E8EAF6;
                    border: 1px solid #7986CB;
                    border-radius:8px; 
                    color: #2e2e2e;
                    height: 90px;
                    width: 170px;
                ">
                    <div class="d-flex flex-column justify-center flex-grow-1">
                        <div class="card-title">Training Hours</div>
                        <div class="card-count">
                            {{ total_training_hours }}<small v-if="total_training_minutes > 0">h {{ total_training_minutes }}m</small><small v-else>h</small>
                        </div>
                    </div>
                    <v-icon large class="ml-4" color="#3F51B5">mdi-clock-outline</v-icon>
                </v-card>
            </v-hover>
        </div>
    </div>
</template>

            </div>
        </v-card>

        <!-- <v-card class="box pa-3">
            <v-row justify="center">
                <v-col cols="12" sm="6" md="3">
                    <v-autocomplete v-model="selected_ay" :items="academicyear_list" item-text="ay" item-value="id"
                        outlined dense rounded required @change="onchange_method">
                        <template #label>
                            Academic Year<span style="color: red;">*</span>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                    <v-autocomplete v-model="selected_semester" :items="semester_list" item-text="name" item-value="id"
                        outlined dense rounded required @change="render_update">
                        <template #label>
                            Semester<span style="color: red;">*</span>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                    <v-autocomplete v-model="selected_standard" :items="standard_list" item-text="name" item-value="id"
                        outlined dense rounded required @change="onchange_method" multiple>
                        <template #label>
                            Standard<span style="color: red;">*</span>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                    <v-autocomplete v-model="selected_div" :items="division_list" item-text="division" item-value="id"
                        outlined dense rounded required @change="render_update" multiple>
                        <template #label>
                            Division<span style="color: red;">*</span>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                    <v-autocomplete v-model="selected_course" :items="course_list" item-text="name" item-value="id"
                        outlined dense rounded required @change="onchange_method">
                        <template #label>
                            Course<span style="color: red;">*</span>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                    <v-autocomplete v-model="selected_learner" :items="learner_list" item-text="name" item-value="id"
                        outlined dense rounded required @change="render_update">
                        <template #label>
                            Learner<span style="color: red;">*</span>
                        </template>
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="pa-4 my-2 elevation-2" dense
                style=" 
background-image: radial-gradient(circle at 28% 51%, rgba(206, 206, 206,0.03) 0%, rgba(206, 206, 206,0.03) 17%,transparent 17%, transparent 100%),radial-gradient(circle at 45% 10%, rgba(10, 10, 10,0.03) 0%, rgba(10, 10, 10,0.03) 45%,transparent 45%, transparent 100%),radial-gradient(circle at 48% 44%, rgba(74, 74, 74,0.03) 0%, rgba(74, 74, 74,0.03) 84%,transparent 84%, transparent 100%),radial-gradient(circle at 47% 50%, rgba(186, 186, 186,0.03) 0%, rgba(186, 186, 186,0.03) 23%,transparent 23%, transparent 100%),radial-gradient(circle at 29% 70%, rgba(9, 9, 9,0.03) 0%, rgba(9, 9, 9,0.03) 32%,transparent 32%, transparent 100%),radial-gradient(circle at 2% 75%, rgba(179, 179, 179,0.03) 0%, rgba(179, 179, 179,0.03) 19%,transparent 19%, transparent 100%),radial-gradient(circle at 2% 36%, rgba(26, 26, 26,0.03) 0%, rgba(26, 26, 26,0.03) 1%,transparent 1%, transparent 100%),radial-gradient(circle at 53% 70%, rgba(90, 90, 90,0.03) 0%, rgba(90, 90, 90,0.03) 55%,transparent 55%, transparent 100%),radial-gradient(circle at 28% 92%, rgba(31, 31, 31,0.03) 0%, rgba(31, 31, 31,0.03) 35%,transparent 35%, transparent 100%),linear-gradient(90deg, rgb(255,255,255),rgb(255,255,255));                            border-radius: 20px;">
                <v-col cols="2" v-for="(item, index) in tabs" :key="index">
                    <v-btn text class="custom-tabs elevation-2" block :class="{ 'active': tab === index }"
                        @click="tab = index; render_update()">
                        {{ item }}
                    </v-btn>
                </v-col>
            </v-row>

            <v-divider></v-divider>
            <v-window v-model="tab">
                <v-window-item v-for="(item, index) in tabs" :key="index" :value="index">
                    <component :is="components[index]" :key="render1[index]" :selected_ay="selected_ay"
                        :selected_semester="selected_semester" :selected_standard="selected_standard"
                        :selected_div="selected_div" :selected_course="selected_course"
                        :selected_learner="selected_learner" />
                </v-window-item>
            </v-window>
        </v-card> -->
    </div>
</template>

<script>
    import axios from "axios";
    // import AdmissionDashboard from '../AdminDashboard/AdmissionDashboard.vue'
    // import FeesDashboard from "./FeesDashboard.vue";
    // import ResultsDashboard from "./ResultsDashboard.vue";
    // import TransportDashboard from "./TransportDashboard.vue";
    // import AcademicsDashboard from "./AcademicsDashboard.vue";
    // import AppriasalDashboard from "./AppriasalDashboard.vue";
    // import LeaveDashboard from "./LeaveDashboard.vue";
    export default {
        components: {
            // AdmissionDashboard,
            // FeesDashboard,
            // ResultsDashboard,
            // TransportDashboard,
            // AcademicsDashboard,
            // AppriasalDashboard,
            // LeaveDashboard,
        },
        data() {
            return {
                // tab: 0,
                // tabs: [
                //     "Admissions", "Fees", "Results", "Transport",
                //     "Academics", "Appraisal", "Feedback", "Leave",
                // ],
                total_training_hours: null,
                total_training_minutes: null,
                selected_ay: "",
                selected_semester: "",
                selected_standard: [],
                selected_div: [],
                selected_course: "",
                selected_learner: "",
                academicyear_list: [],
                semester_list: [],
                standard_list: [],
                division_list: [],
                course_list: [],
                learner_list: [],
                admin_side_student_teacher_parent_staff_list: [],
                total_publications: null,
                total_book_reviewed: null,
                performance_index_count: null,
                total_training_imparted: 0,
                total_training_undergone: 0,

                new_admission_count: null,
                expected_amount: null,
                total_paid_till_now: null,
                last_year_fees_due: null,
                student_present_today_count: null,
                total_training_imparted: null,
                app_login_user: null,
                web_login_user: null,
                appraisal_score: null,
                avg_feedback_score: null,
                color: "",
                snackbar: false,
                snackbar_msg: null,
                render1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                components: [
                    // "AdmissionDashboard",
                    // "FeesDashboard",
                    // "ResultsDashboard",
                    // "TransportDashboard",
                    // "AcademicsDashboard",
                    // "AppriasalDashboard",
                    // "LeaveDashboard",
                ],
            };
        },
        computed: {
            cardData() {
                if (
                    !this.admin_side_student_teacher_parent_staff_list ||
                    this.admin_side_student_teacher_parent_staff_list.length === 0
                ) return [];
                const data = this.admin_side_student_teacher_parent_staff_list[0];
                return [
                    {
                        title: "Students",
                        count: data.learner_total_count,
                        bg: "#E8F5E9",
                        border1: "1px solid #81C784",
                        icon: "mdi-account-school",
                        iconColor: "#388E3C"
                    },
                    {
                        title: "Parents",
                        count: data.parent_total_count,
                        bg: "#F3E5F5",
                        border1: "1px solid #BA68C8",
                        icon: "mdi-account-supervisor",
                        iconColor: "#8E24AA"
                    },
                    {
                        title: "Teachers",
                        count: data.teacher_total_count,
                        bg: "#E3F2FD",
                        border1: "1px solid #90CAF9",
                        icon: "mdi-account-tie",
                        iconColor: "#1976D2"
                    },
                    {
                        title: "Staff",
                        count: data.staff_total_count,
                        bg: "#FFF3E0",
                        border1: "1px solid #FFB74D",
                        icon: "mdi-account-badge",
                        iconColor: "#F57C00"
                    }
                ];
            },





        },
        mounted() {
            this.onload();
            this.getAllCountForDashboad();
            // this.getFeedbackScore();
            this.getPerformanceIndex();
            this.getBooksCount();
            this.getTotalPublications();
            this.getTraingingImpartedCount();
            this.getTrainingUndergoneCount();
            this.getTotalTrainingHours();
        },
        methods: {
            formatNumber(num) {
                if (num == null || isNaN(num)) return "0";

                const absNum = Math.abs(num);

                if (absNum >= 1e7) {
                    return (num / 1e7).toFixed(2) + " Cr"; // Crores
                } else if (absNum >= 1e5) {
                    return (num / 1e5).toFixed(2) + " L";  // Lakhs
                } else if (absNum >= 1e3) {
                    return (num / 1e3).toFixed(2) + " K";  // Thousands
                } else {
                    return num.toString(); // Small values
                }
            },
            render_update() {
                this.$nextTick().then(() => {
                    this.render1[this.tab] = this.render1[this.tab] + 1;
                });
            },
            showSnackbar(color, msg) {
                this.snackbar = true;
                this.color = color;
                this.snackbar_msg = msg;
            },
            onchange_method() {
                if (Array.isArray(this.standard_list) && this.standard_list.length > 0) {
                    this.getDivisionAndCourse();
                    this.getLearners();
                }
                this.render_update();
            },
            async onload() {
                const res = await axios.post("/AdminDashboard/getAySemStdListForDashboard");
                if (res.data.msg === "200") {
                    this.academicyear_list = res.data.academicyear_list;
                    this.semester_list = res.data.semester_list;
                    this.standard_list = res.data.standard_list;

                    this.selected_ay =
                        res.data.active_ay ||
                        (this.academicyear_list.length > 0 ? this.academicyear_list[0].id : "");

                    this.selected_semester =
                        (this.semester_list.length > 0 ? this.semester_list[0].id : "");


                    this.selected_standard =
                        this.standard_list.length > 0 ? [this.standard_list[2].id] : [];

                    if (this.selected_standard.length > 0) this.getDivisionAndCourse();


                } else {
                    this.showSnackbar("error", res.data.msg || "Failed to load data");
                }
            },
            async getDivisionAndCourse() {
                if (!this.selected_standard || this.selected_standard.length === 0) return;

                const data = {
                    selected_standard: this.selected_standard, // send array
                    selected_ay: this.selected_ay,
                };

                try {
                    const res = await axios.post("/AdminDashboard/getDivAndCourseLiatFromStd", data);
                    if (res.data.msg === "200") {
                        this.division_list = res.data.division_list || [];
                        this.course_list = res.data.course_list || [];

                        //    this.selected_div =
                        //     this.division_list.length > 0 ? [this.division_list[1].id] : [];
                        this.selected_div =
                            this.division_list.length > 0
                                ? this.division_list.map((d) => d.id)
                                : [];


                        this.selected_course =
                            this.course_list.length > 0 ? this.course_list[0].id : "";

                        if (this.selected_course) this.getLearners();
                    } else {
                        this.showSnackbar("error", res.data.msg);
                    }
                } catch (error) {
                    this.showSnackbar("error", "Error fetching divisions/courses");
                }
            },

            async getLearners() {
                const data = {
                    selected_ay: this.selected_ay,
                    selected_standard: this.selected_standard,
                    selected_course: this.selected_course
                };
                const res = await axios.post("/AdminDashboard/getLearnerLiatFromCourseAyStd", data);
                if (res.data.msg == "200") {
                    this.learner_list = res.data.learner_list;
                    this.selected_learner = this.learner_list[0].id || "";
                } else {
                    this.showSnackbar("error", res.data.msg);
                }
            },
            async getAllCountForDashboad() {
                const res = await axios.post("/AdminDashboard/getAllCountForDashboad");
                if (res.data.msg === "200") {
                    this.admin_side_student_teacher_parent_staff_list = res.data.admin_side_student_teacher_parent_staff_list;
                    // this.other_education_count = res.data.other_education_count;
                } else {
                    this.showSnackbar("error", res.data.msg || "Failed to load data");
                }
            },
            // async getFeedbackScore() {

            // },
            async getPerformanceIndex() {
                try {
                    const res = await axios.post("/FacultyDashboard/getPerformanceIndex");

                    console.log("Performance Index  response:", res.data);

                    if (res.data.flag === "YES") {
                        this.performance_index_count = Number(res.data.performance_index_count) || 0;
                    } else {
                        this.performance_index_count = 0;
                    }
                } catch (error) {
                    console.error("Error loading Performance Index count:", error);
                    this.performance_index_count = 0;
                    this.showSnackbar("error", "Failed to load Performance Index  count");
                }
            },
            async getBooksCount() {
                try {
                    const res = await axios.post("/FacultyDashboard/getBooksCount");

                    console.log("Book response:", res.data);

                    if (res.data.flag === "YES") {
                        this.total_book_reviewed = Number(res.data.total_book_reviewed) || 0;
                    } else {
                        this.total_book_reviewed = 0;
                    }
                } catch (error) {
                    console.error("Error loading Book:", error);
                    this.total_book_reviewed = 0;
                    this.showSnackbar("error", "Failed to load Book count");
                }
            },

            async getTotalPublications() {
                try {
                    const res = await axios.post("/FacultyDashboard/getTotalInstructorPublicationsCount");

                    console.log("Publications response:", res.data);

                    if (res.data.flag === "YES") {
                        this.total_publications = Number(res.data.total_publications) || 0;
                    } else {
                        this.total_publications = 0;
                    }
                } catch (error) {
                    console.error("Error loading publications:", error);
                    this.total_publications = 0;
                    // this.showSnackbar("error", "Failed to load publications count");
                }
            },
            async getTraingingImpartedCount() {
                try {
                    const res = await axios.post("/FacultyDashboard/getTotalInstructorTrainingImpartedCount");

                    console.log("Training Imparted response:", res.data);

                    if (res.data.flag === "YES") {
                        this.total_training_imparted = Number(res.data.total_training_imparted) || 0;
                    } else {
                        this.total_training_imparted = 0;
                    }
                } catch (error) {
                    console.error("Error loading training imparted count:", error);
                    this.total_training_imparted = 0;
                    // this.showSnackbar("error", "Failed to load training imparted count");
                }
            },
            async getTrainingUndergoneCount() {
                try {
                    const res = await axios.post("/FacultyDashboard/getTotalInstructorTrainingUndergoneCount");
                    if (res.data.flag === "YES") {
                        this.total_training_undergone = Number(res.data.total_training_undergone) || 0;
                    } else {
                        this.total_training_undergone = 0;
                    }
                } catch (error) {
                    console.error(error);
                    this.total_training_undergone = 0;
                }
            },
            async getTotalTrainingHours() {
    try {
        const res = await axios.post("/FacultyDashboard/getTotalInstructorTrainingHours");
        console.log("Training Hours response:", res.data);

        if (res.data.flag === "YES") {
            this.total_training_hours = Number(res.data.total_training_hours) || 0;
            this.total_training_minutes = Number(res.data.total_training_minutes) || 0;
        } else {
            this.total_training_hours = 0;
            this.total_training_minutes = 0;
        }
    } catch (error) {
        console.error("Error loading training hours:", error);
        this.total_training_hours = 0;
        this.total_training_minutes = 0;
        this.showSnackbar("error", "Failed to load training hours");
    }
},
        }
    };
</script>

<style scoped>
    .custom-tabs {
        background-color: white;
        border-radius: 4px;
        text-transform: none;
        font-weight: 500;
        justify-content: center;
        white-space: nowrap;
        display: flex;
        align-items: center;
        height: 40px;
    }

    .custom-tabs.v-btn--active,
    .custom-tabs.active {
        border-bottom: 3px solid #7045e6;
        background-color: transparent;
    }

    .custom-tabs:hover {
        background-color: #f0f0f5;
    }

    .responsive-card {
        transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

    .card-title {
        font-size: 12px;
        font-weight: 500;
        color: #555;
        font-family: "Roboto", sans-serif;
    }

    .card-count {
        font-size: 16px;
        font-weight: 700;
        color: #2e2e2e;
        font-family: "Poppins", sans-serif;
    }

    .custom-tabs {
        font-weight: 500;
        font-size: 14px;
        text-transform: none;
        color: #555;
        border-radius: 28px;
        transition: all 0.3s ease;
        position: relative;
        padding: 10px 15px;
        margin-bottom: 5px;
    }

    .custom-tabs:hover {
        background-color: #f0f4ff;
        color: #541ae8;
        transform: translateY(-2px);
        border: 1px solid #541ae8;
    }

    .custom-tabs.active {
        background-color: #9e6ef6;
        color: #fff;
        box-shadow: 0 4px 12px rgba(102, 26, 232, 0.25);
    }

    .custom-tabs::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 15px;
        right: 15px;
        height: 3px;
        background-color: #432694;
        border-radius: 2px;
        transform: scaleX(0);
        transition: transform 0.3s ease;
    }

    @media (max-width: 960px) {
        .responsive-card {
            width: calc(50% - 16px);
        }
    }

    @media (max-width: 600px) {
        .responsive-card {
            width: 100%;
        }
    }
</style>